import React, { Component } from 'react';
import { Transition } from 'react-transition-group';
import { TweenMax } from 'gsap';

import style from './index.module.scss';

export default class Background extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false
    }

    this.handleAnimationComplete = this.handleAnimationComplete.bind(this);
  }

  animateIn() {
    if (this.props.skipFade) TweenMax.set(this.background, { opacity: 1 });
    else TweenMax.to(this.background, 1, { opacity: 1, delay: 0.75 });
  }

  animateOut() {
		TweenMax.to(this.background, 1, { opacity: 0 });
  }

  handleAnimationComplete() {
    this.setState(() => ({ active: true }));
  }

  componentDidMount() {
    const { index, skipFade } = this.props;
    console.log('component did mount', skipFade);
    if (index === 0 || skipFade) TweenMax.set(this.background, { opacity: 1 });
    else TweenMax.set(this.background, { opacity: 0 });
  }
  
  render() {
    const { className, show, image } = this.props;

    return (
      <Transition
        timeout={0}
        in={show}
        addEndListener={(node, done) => show ? this.animateIn() : this.animateOut()}>
      	<div className={`${style['background-image']} ${className || ''}`}
          style={{ backgroundImage: `url('${image}')` }}
          ref={instance => this.background = instance}></div>
      </Transition>
    )
  }
}
